(function () {
  'use strict';
  const configNode = document.getElementById('ds-preview-config');
  const assetNode = document.getElementById('ds-preview-assets');
  if (!configNode || !assetNode) return;
  const config = JSON.parse(configNode.textContent);
  const assets = JSON.parse(assetNode.textContent);
  window.DS_PREVIEW_CONFIG = config;
  window.DS_PREVIEW_ASSETS = assets;
  const preview = config.isPreview !== false;
  const localeRoot = String(config.rootUrl || '/').replace(/\/$/, '') + '/';
  const localHosts = new Set([location.hostname, 'diamondstudio.com', 'www.diamondstudio.com', 'diamondstudio.myshopify.com']);

  function route(value) {
    const original = String(value || '');
    if (original.startsWith('#') || /^(?:mailto:|tel:|javascript:)/i.test(original)) return original;
    let url;
    try { url = new URL(original || config.rootUrl || '/', location.href); } catch (_) { return original; }
    if (!/^https?:$/.test(url.protocol) || !localHosts.has(url.hostname)) return original;
    if (localeRoot !== '/' && !url.pathname.startsWith(localeRoot)) {
      if (url.pathname === '/') url.pathname = localeRoot;
      else if (/^\/(?:products|collections|pages|blogs|search|cart|account)(?:\/|$)/.test(url.pathname)) url.pathname = localeRoot + url.pathname.slice(1);
    }
    const productRoute = /\/products\//.test(url.pathname);
    const cartRoute = /\/(?:cart|checkout)(?:\/|$)/.test(url.pathname);
    url.searchParams.delete('preview_theme_id');
    if (['ds-preview', 'ds-release'].includes(url.searchParams.get('view'))) url.searchParams.delete('view');
    if (preview && config.themeId && !cartRoute) {
      url.searchParams.set('preview_theme_id', String(config.themeId));
      if (productRoute) url.searchParams.set('view', config.previewView || 'ds-release');
    }
    return url.pathname + url.search + url.hash;
  }
  window.DS_PRODUCT_ROUTE = route;

  window.DS_PREVIEW_HYDRATE = function ({ DS, CAMILLA_SOURCE }) {
    if (DS && Array.isArray(DS.products)) DS.products.forEach(function (card, index) {
      const current = config.catalog?.[index];
      if (!current || !current.id) {
        card.previewMissing = true;
        card.available = false;
        return;
      }
      card.title = current.title;
      card.price = current.price; card.compare_at_price = current.compare_at_price;
      card.available = current.available;
      card.url = route('/products/' + current.handle);
    });
    if (CAMILLA_SOURCE && config.productData) {
      CAMILLA_SOURCE.title = config.productData.title;
      CAMILLA_SOURCE.description = config.productData.description;
      CAMILLA_SOURCE.price = config.productData.price;
    }
  };

  // Product-only links use the active locale and preserve option/hash context.
  // Cart, checkout and app forms remain owned by the store's commerce adapters.
  document.addEventListener('click', function (event) {
    const anchor = event.target.closest('a[href]');
    if (!anchor) return;
    const original = anchor.getAttribute('href');
    if (!original || original.startsWith('#')) return;
    anchor.href = route(original);
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    document.documentElement.style.setProperty('--ds-preview-toolbar-height', '0px');
    if (!preview) return;
    const frames = new WeakSet();
    function measureToolbar() {
      const frame = document.getElementById('PBarNextFrameWrapper') || document.getElementById('PBarNextFrame');
      const box = frame?.getBoundingClientRect();
      const visible = frame && getComputedStyle(frame).display !== 'none';
      const height = visible && box.height > 0 && box.height < 220 ? Math.ceil(box.height) : 0;
      document.documentElement.style.setProperty('--ds-preview-toolbar-height', height + 'px');
      if (frame && !frames.has(frame)) {
        frames.add(frame);
        new ResizeObserver(measureToolbar).observe(frame);
      }
    }
    new MutationObserver(measureToolbar).observe(document.body, { childList: true });
    window.addEventListener('resize', measureToolbar);
    measureToolbar();
  });
})();
